import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Products } from "../Model/AltProductPortfolioPageModel";

const AltProductPortfolioController = () => {
  const { productname } = useParams();
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(1);
  const [productIndex, setProductIndex] = useState(null);
  const sectionRefs = useRef([]);


  const items = [
    "szephyr",
    "smazer",
    "smampmax",
    "innomate",
    "RedunLink_RS232-2F",
    "serialtoredundantfiberextender",
    "RelaiLink_UHF-X",
    "RuggedEdge_MPU-65",
    "InduX_Edge_8",
    "vidyuraksha_2.0",
    "SensiConnect_1612_PRO",
    // "RugEdge_V3000",
    // "RugEdge_R8000",
    "industrialrugged16portl2managedswitch",
    "industrialrugged16portunmanagedswitch",
    "industrialrugged8portl2managedswitch",
    "industrialrugged24portl2managedswitch",
    "dualredundantpowersupply",
    "displaycontrollers",
    "serialinterfacecards",
    // "webandcloudsolutions",
    // "mobileapplications"
  ];

  useEffect(() => {
    console.log("productName",productname)
    const refproductname = items.indexOf(productname);
    console.log("refproductname",refproductname)
    setProductIndex(refproductname);
  }, [productname]);

  useEffect(() => {
    if (productIndex === -1) {
      navigate("/comingsoon");
    }
  }, [productIndex, navigate]);


  useEffect(() => {
    let timeout;

    const handleScroll = () => {
      clearTimeout(timeout);

      timeout = setTimeout(() => {
        const steps = Products[productIndex]?.steps || [];
        const offsets = steps
          .map(({ key }) => {
            const ref = sectionRefs.current[key];
            if (!ref) return null;
            const rect = ref.getBoundingClientRect();
            return { key, offset: Math.abs(rect.top) };
          })
          .filter(Boolean);

        if (offsets.length === 0) return;

        const closest = offsets.reduce((prev, curr) =>
          curr.offset < prev.offset ? curr : prev
        );

        const closestIndex = steps.findIndex((s) => s.key === closest.key);

        if (closestIndex !== -1 && currentStep !== closestIndex + 1) {
          setCurrentStep(closestIndex + 1);
        }
      }, 50);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();

    return () => {
      clearTimeout(timeout);
      window.removeEventListener("scroll", handleScroll);
    };
  }, [currentStep, productIndex]);



  const scrollToStep = (stepIndex, e, key) => {
    e.preventDefault();
    e.currentTarget.blur();
    const section = sectionRefs.current[key];
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
      setCurrentStep(stepIndex + 1);
    }
  };

  const product = Products[productIndex];

  const useIsMobile = () => {
    const [isMobile1, setIsMobile1] = useState(false);
    const [isMobile2, setIsMobile2] = useState(false);
    const [isMobile3, setIsMobile3] = useState(false);

    useEffect(() => {
      const checkMobile = () => {
        setIsMobile1(window.innerWidth <= 520);
        setIsMobile2(window.innerWidth <= 1024);
        setIsMobile3(window.innerWidth <= 1200)
      };

      checkMobile();
      window.addEventListener("resize", checkMobile);

      return () => {
        window.removeEventListener("resize", checkMobile);
      };
    }, []);

    return { isMobile1, isMobile2, isMobile3 };
  };

  return {
    currentStep,
    setCurrentStep,
    sectionRefs,
    scrollToStep,
    productIndex,
    product,
    useIsMobile
  };
};

export default AltProductPortfolioController;